import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from 'core/services';
import { filter, map, switchMap } from 'rxjs';

@Component({
  selector: 'ss-core-subtle-loader-outlet',
  templateUrl: './subtle-loader-outlet.component.html',
  styleUrls: ['./subtle-loader-outlet.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubtleLoaderOutletComponent {
  readonly loadersObs = this._loaderService.loadersSubject.pipe(
    map(loaders =>
      Object.values(loaders)
        .filter(({ subtle, key }) => subtle)
    ),
  );
  readonly loaderDisplaysObs = this.loadersObs.pipe(
    map((loaders) => loaders
      .filter(loader => loader.text)
      .map((loader) => loader.text)
    ),
    filter((textKeys) => Boolean(textKeys.length)),
    switchMap((textKeys) => this._translateService.get(textKeys)),
    map((translations) => Object.values(translations))
  )

  readonly showLoaderObs = this.loadersObs.pipe(map(loaders => Boolean(loaders.length)))

  constructor(
    private readonly _loaderService: LoaderService,
    private readonly _translateService: TranslateService
  ) {

  }
}
